import { useTranslation } from 'react-i18next';

import { AudioCard } from '@app/shared/ui/molecules/Development';
import { MediaData } from '@app/shared/types/player';
import { CooldownContainer } from '@app/shared/ui/molecules/Common';
import { LOCAL_STORAGE, TWELVE_HOURS_MS } from '@app/shared/constants/common';

interface AudioListProps {
  audioList: MediaData[];
  onCardClick: (item: MediaData) => void;
}

export const AudioList = ({ audioList, onCardClick }: AudioListProps) => {
  const { t } = useTranslation();

  return (
    <ul className="space-y-2 px-2">
      {audioList.map((item) => (
        <li key={item.id}>
          <CooldownContainer
            itemId={String(item.id)}
            intervalMs={TWELVE_HOURS_MS}
            onClick={() => {
              onCardClick(item);
            }}
            storageKey={LOCAL_STORAGE.media}
            timerClassName="font-semibold"
          >
            <AudioCard title={t(`media.title.${item.title}`)} isLocked={item.isLocked} />
          </CooldownContainer>
        </li>
      ))}
    </ul>
  );
};
